import React from 'react';
import { StyledTab } from '../../../styles/globalStyles';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';
import { setFluids } from '../../../store/slices/metaDataSlice';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export const TabPanel = () => {
  const {
    estimatingRequirements: { fluids }
  } = useAppSelector(metaDataSelector);
  const dispatch = useDispatch();

  const handleChange = (event: any, newValue: number) => {
    dispatch(
      setFluids({
        ...fluids,
        additionalFluids: newValue
      })
    );
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <StyledTab
          value={fluids.additionalFluids}
          onChange={handleChange}
          aria-label="Tabs example"
        >
          <Tab label={'2 mL/kg'} tabIndex={0} {...a11yProps(0)} />
          <Tab label={'2.5 mL/kg'} tabIndex={0} {...a11yProps(1)} />
          <Tab label={'none'} tabIndex={0} {...a11yProps(2)} />
        </StyledTab>
      </Box>
    </Box>
  );
};
